var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    staticClass: "visual text-center white--text",
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('v-img', {
    staticClass: "mb-6 mb-md-8 w-180px w-md-260px",
    attrs: {
      "src": "/images/logo.png",
      "max-width": "100%",
      "contain": ""
    }
  }), _c('div', {
    staticClass: "visual__title mb-4 mb-md-6 px-10px px-md-0 mw-100",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": _vm.$vuetify.breakpoint.mdAndUp ? 200 : 0
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/event/hunt/title.png",
      "max-width": "100%",
      "width": "750",
      "aspect-ratio": 750 / 380,
      "contain": "",
      "alt": "대한문고가 쏜다 여름맞이 보물찾기 EVENT!"
    }
  }), _c('v-img', {
    staticClass: "icon-watergun",
    attrs: {
      "src": "/images/event/hunt/icon-watergun.svg",
      "aspect-ratio": 176 / 132
    }
  })], 1), _c('h3', {
    staticClass: "tit tit--sm text-shadow",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("이벤트 진행 기간")]), _c('h4', {
    staticClass: "tit font-weight-black text-shadow",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": _vm.$vuetify.breakpoint.mdAndUp ? 50 : 0
    }
  }, [_vm._v("2023.07.17 ~ 2023.07.30")]), _c('v-layout', {
    staticClass: "mt-50px mt-md-80px mt-lg-110px",
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('h4', {
    staticClass: "tit text-shadow mb-4 mb-md-6",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("참여방법")]), _c('v-row', {
    staticClass: "ma-n2 ma-md-n8",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-2 pa-md-8",
    attrs: {
      "cols": "12",
      "sm": "auto",
      "data-aos": "fade-up",
      "data-aos-delay": _vm.$vuetify.breakpoint.mdAndUp ? 50 : 0
    }
  }, [_c('h5', {
    staticClass: "txt txt--xl text-shadow"
  }, [_vm._v("대한문고 "), _c('br'), _vm._v("로그인")])]), _c('v-col', {
    staticClass: "pa-2 pa-md-8",
    attrs: {
      "cols": "auto",
      "data-aos": "fade-up",
      "data-aos-delay": _vm.$vuetify.breakpoint.mdAndUp ? 100 : 0
    }
  }, [_c('i', {
    staticClass: "icon icon-right-arrow mt-sm-2 mt-md-3"
  })]), _c('v-col', {
    staticClass: "pa-2 pa-md-8",
    attrs: {
      "cols": "12",
      "sm": "auto",
      "data-aos": "fade-up",
      "data-aos-delay": _vm.$vuetify.breakpoint.mdAndUp ? 100 : 0
    }
  }, [_c('h5', {
    staticClass: "txt txt--xl text-shadow"
  }, [_vm._v("이벤트 페이지에서 "), _c('br'), _vm._v("보물상자 고르기")])]), _c('v-col', {
    staticClass: "pa-2 pa-md-8",
    attrs: {
      "cols": "auto",
      "data-aos": "fade-up",
      "data-aos-delay": _vm.$vuetify.breakpoint.mdAndUp ? 150 : 0
    }
  }, [_c('i', {
    staticClass: "icon icon-right-arrow mt-sm-2 mt-md-3"
  })]), _c('v-col', {
    staticClass: "pa-2 pa-md-8",
    attrs: {
      "cols": "12",
      "sm": "auto",
      "data-aos": "fade-up",
      "data-aos-delay": _vm.$vuetify.breakpoint.mdAndUp ? 200 : 0
    }
  }, [_c('h5', {
    staticClass: "txt txt--xl text-shadow text-sm-left mb-1"
  }, [_vm._v("당첨 상품확인")]), _c('p', {
    staticClass: "txt txt--sm font-weight-bold text-shadow text-sm-left",
    staticStyle: {
      "color": "rgba(255, 255, 255, 0.5)"
    }
  }, [_vm._v(" 당첨된 상품은 마이페이지 "), _c('br'), _vm._v(" ‘이벤트 참여내역’에서 확인 가능 ")])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }